module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, null) > -1 : (_vm.selected)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selected = $$c
        }
      }, _vm.onCheckChange]
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-502594b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/SelectRowComponent.vue
// module id = 1286
// module chunks = 2